import React from 'react';
import PropTypes from 'prop-types';
import HistoryGraph from '../HistoryGraph/HistoryGraph';

const HistoryModal = ({ isOpen, onClose, history, gameName, filterKey, filterValue }) => {
    if (!isOpen) return null;

    const filteredHistory = filterKey && filterValue 
        ? history.filter(item => item[filterKey] === filterValue)
        : history;

    return (
        <div style={modalOverlayStyle}>
            <div style={modalContentStyle}>
                <div style={modalHeaderStyle}>
                    <h2 style={{ margin: 0 }}>{gameName} Performance</h2>
                    <button onClick={onClose} style={closeButtonStyle}>×</button>
                </div>
                
                <div style={modalBodyStyle}>
                    <HistoryGraph 
                        data={filteredHistory} 
                        title={filterValue ? `Total Time Progress: ${filterValue}` : 'Total Time Progress'} 
                        color={gameName.includes('Samurai') ? '#e74c3c' : '#3498db'}
                        dataKey="time"
                    />

                    {filteredHistory.some(d => d.firstShot) && (
                        <HistoryGraph 
                            data={filteredHistory} 
                            title="First Shot Progress" 
                            color="#f39c12"
                            dataKey="firstShot"
                            binSize={0.1}
                        />
                    )}

                    {filteredHistory.some(d => d.avgSplit) && (
                        <HistoryGraph 
                            data={filteredHistory} 
                            title="Average Split Progress" 
                            color="#9b59b6"
                            dataKey="avgSplit"
                            binSize={0.05}
                        />
                    )}

                    {(filterValue === '7-Yard Draw' || filterValue === '25-Yard Shot') && filteredHistory.some(d => d.totalClicks) && (
                        <HistoryGraph 
                            data={filteredHistory} 
                            title="Total Clicks (Including Misses)" 
                            color="#e67e22"
                            dataKey="totalClicks"
                            binSize={1}
                        />
                    )}
                </div>

                <div style={modalFooterStyle}>
                    <div style={{ display: 'flex', gap: '20px', color: '#888', fontSize: '11px' }}>
                        <div>{filteredHistory.length} sessions</div>
                        {filteredHistory.some(d => d.firstShot) && (
                            <>
                                <div>Best First: {Math.min(...filteredHistory.filter(d => d.firstShot).map(d => d.firstShot)).toFixed(3)}s</div>
                                <div>Best Split: {Math.min(...filteredHistory.filter(d => d.avgSplit).map(d => d.avgSplit)).toFixed(3)}s</div>
                            </>
                        )}
                    </div>
                    <button onClick={onClose} style={closeBtnActionStyle}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

const modalOverlayStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.85)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    backdropFilter: 'blur(5px)',
};

const modalContentStyle = {
    background: '#1a1a2e', border: '1px solid #2c3e50', borderRadius: '12px',
    width: '90%', maxWidth: '800px', maxHeight: '80%',
    display: 'flex', flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
    color: '#eee',
};

const modalHeaderStyle = {
    padding: '20px', borderBottom: '1px solid #2c3e50',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
};

const modalBodyStyle = {
    padding: '20px 20px 40px 20px', overflowY: 'auto', flex: 1,
};

const modalFooterStyle = {
    padding: '16px 20px', borderTop: '1px solid #2c3e50',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
};

const closeButtonStyle = {
    background: 'none', border: 'none', color: '#888', fontSize: '28px',
    cursor: 'pointer', padding: '0 10px',
};

const closeBtnActionStyle = {
    background: '#333', color: '#eee', border: 'none',
    padding: '8px 24px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold',
};

HistoryModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    history: PropTypes.arrayOf(PropTypes.object).isRequired,
    gameName: PropTypes.string.isRequired,
    filterKey: PropTypes.string,
    filterValue: PropTypes.string,
};

export default HistoryModal;
